import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Equipment.frontend.types'

@Injectable({ providedIn: 'root' })
export class Equipment_create_equipment_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { equipment?: { lookupCode: string, typeId: number, macAddress?: string, warehouses?: { warehouseId: number }[] } }): Promise<{ equipmentId?: number, reasons?: string[], result?: any }> 
  {
    let url = `${environment.backendUrl}api/Equipment/functions/create_equipment_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

